<template>
  <div class="foucs-strategy-content">
    <el-form label-postion="left" label-width="140px">
      <el-form-item label="策略名称">
        <el-input
          placeholder="请输入策略名"
          v-model="editOne.title"
        ></el-input>
      </el-form-item>
      <el-form-item label="策略类型">
        <el-radio-group v-model="editOne.isConcentratorPlan" disabled>
          <el-radio :label="1">集控策略</el-radio>
          <el-radio :label="0">回路策略</el-radio>
        </el-radio-group>
      </el-form-item>
      <hr />
      <template v-if="editOne.isConcentratorPlan==1||editOne.isConcentratorPlan=='1'">
        <div
          class="item-one"
          v-for="(value, key, index) in editOne.concentratorPlan"
          :key="key"
        >
          <div class="item-odr">计划{{index+1}}</div>
          <div class="item-con">
            <div class="item-time">
              <div class="item-t">时间1</div>
              <div class="item-b">
                <el-time-picker
                  v-model="value[0].date"
                  placeholder="选择时间"
                  value-format="HH:mm"
                  format="HH:mm"
                >
                </el-time-picker>
              </div>
              <div class="item-s">
                <el-radio-group v-model="value[0].action">
                  <el-radio :label="'on'">开</el-radio>
                  <el-radio :label="'off'">关</el-radio>
                </el-radio-group>
              </div>
            </div>

            <div class="item-time">
              <div class="item-t">时间2</div>
              <div class="item-b">
                <el-time-picker
                  v-model="value[1].date"
                  placeholder="选择时间"
                  value-format="HH:mm"
                  format="HH:mm"
                >
                </el-time-picker>
              </div>
              <div class="item-s">
                <el-radio-group v-model="value[1].action">
                  <el-radio :label="'on'">开</el-radio>
                  <el-radio :label="'off'">关</el-radio>
                </el-radio-group>
              </div>
            </div>

          </div>
          <div class="item-remove">
            <el-button class="remove" type="danger" @click="removePlan(key)"
                >删除</el-button
              >
          </div>
        </div>
        <div class="item-add">
          <el-button type="primary" @click="addPlan()">新建计划</el-button>
        </div>
      </template>
      <template v-else>
        <div
          class="loop-plan"
          v-for="(plan, k, i) in editOne.loopPlan"
          :key="k"
        >
          <div class="loop-one">
            <div class="loop-name">回路{{i+1}}</div>
            <div class="item-one" v-for="(value, key, index) in plan"
          :key="key">
              <div class="item-odr">计划{{index+1}}</div>
              <div class="item-con">
                <div class="item-time">
                  <div class="item-t">时间1</div>
                  <div class="item-b">
                    <el-time-picker
                      v-model="value[0].date"
                      placeholder="选择时间"
                      value-format="HH:mm"
                      format="HH:mm"
                    >
                    </el-time-picker>
                  </div>
                  <div class="item-s">
                    <el-radio-group v-model="value[0].action">
                      <el-radio :label="'on'">开</el-radio>
                      <el-radio :label="'off'">关</el-radio>
                    </el-radio-group>
                  </div>
                </div>

                <div class="item-time">
                  <div class="item-t">时间2</div>
                  <div class="item-b">
                    <el-time-picker
                      v-model="value[1].date"
                      placeholder="选择时间"
                      value-format="HH:mm"
                      format="HH:mm"
                    >
                    </el-time-picker>
                  </div>
                  <div class="item-s">
                    <el-radio-group v-model="value[1].action">
                      <el-radio :label="'on'">开</el-radio>
                      <el-radio :label="'off'">关</el-radio>
                    </el-radio-group>
                  </div>
                </div>

              </div>
              <div class="item-remove">
                <el-button class="remove" type="danger" @click="removePlan(key, k)"
                    >删除</el-button
                  >
              </div>
            </div>
            <div class="item-add">
              <el-button type="primary" @click="addPlan(k)">新建计划</el-button>
            </div>
          </div>
        </div>

      </template>

      <hr />
      <el-button
        type="primary"
        native-type="submit"
        @click.prevent="editStrategy"
        >保存</el-button
      >
      <el-button type="error" @click="cancel">取消</el-button>
    </el-form>
  </div>
</template>
<script>
import strategyApi from "@/api/concentrator/strategy"
export default {
  name: "editStrategy",
  props: {
    editData: {
      type: Object,
    },
  },
  data() {
    return {
      editOne: {
        id: null,
        title: '',
        isConcentratorPlan: 1,
        loopPlan: null,
        concentratorPlan: null,
        ste: 0
      }
    };
  },
  mounted() {
    this.sortData()
  },
  methods: {
    sortData() {
      this.editOne.id = this.editData.id
      this.editOne.title = this.editData.title
      this.editOne.isConcentratorPlan = this.editData.isConcentratorPlan
      this.editOne.loopPlan = this.editData.loopPlan?JSON.parse(this.editData.loopPlan):''
      this.editOne.concentratorPlan = this.editData.concentratorPlan?JSON.parse(this.editData.concentratorPlan):''
      this.editOne.ste = this.editData.ste
      // console.log('sortData', this.editOne)
    },

    removePlan(key, k=null) {
      if (confirm("确定要删除这个计划？")) {
        if(k){
          this.$delete(this.editOne.loopPlan[k], key);
        }else{
          this.$delete(this.editOne.concentratorPlan, key);
        }
      }
    },
    editStrategy() {
      if(!this.editOne.title){
        return this.$message.error("策略名称不能为空");
      }
      if(!this.editOne.loopPlan&&!this.editOne.concentratorPlan){
        return this.$message.error("请填写计划！");
      }
      let params = {
        title: this.editOne.title,
        is_concentrator_plan: this.editOne.isConcentratorPlan,
        loop_plan: this.editOne.loopPlan?JSON.stringify(this.editOne.loopPlan):'',
        concentrator_plan: this.editOne.concentratorPlan?JSON.stringify(this.editOne.concentratorPlan):'',
        ste: this.editOne.ste
      };
      strategyApi.strategyEdit(this.editOne.id, params).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("修改成功")
          this.$emit('closeMethod')
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    addPlan(k = null) {
      if(k){
        let ObjectNum= Object.keys(this.editOne.loopPlan[k]).length+1
        while (this.editOne.loopPlan[k].hasOwnProperty('plan' + ObjectNum)) {
          ObjectNum++;
        }
        this.$set(this.editOne.loopPlan[k], 'plan' + ObjectNum, [
          { "date": "00:00", "action": "on" },
          { "date": "01:00", "action": "off" }
        ]);
      }else{
        let ObjectNum= Object.keys(this.editOne.concentratorPlan).length+1
        while (this.editOne.concentratorPlan.hasOwnProperty('plan' + ObjectNum)) {
          ObjectNum++;
        }
        this.$set(this.editOne.concentratorPlan, 'plan' + ObjectNum, [
          { "date": "00:00", "action": "on" },
          { "date": "01:00", "action": "off" }
        ]);
      }
      
    },
    cancel() {
      this.$emit("closeMethod");
    },
  }
};
</script>

<style lang='less'>
.foucs-strategy-content{
  .item-one{
    padding: 15px 16px;
    border-bottom: 1px solid #eee;
    display: flex;
    align-items: center;
    .item-odr{
      font-size: 14px;
      color:#111;
      margin-right: 20px;
    }
    .item-con{
      flex: 1;
      display: flex;
      align-items: center;
      .item-time{
        margin-right:50px;
        display: flex;
        align-items: center;
        .item-t{
          margin-right: 10px;
        }
        .item-s{
          margin-left: 15px;
          .el-radio{
            margin-right: 15px !important;
          }
        }
      }
    }
    .item-remove{
      margin-left: 0;
    }
  }
  .item-add{
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
  .loop-plan{
    .loop-one{
      border:1px solid #ddd;
      padding: 30px;
      margin-bottom: 40px;
      .loop-name{
        font-size: 18px;
        font-weight: bold;
        text-align: center;
      }
    }
  }
}
</style>